import { useEffect } from "react"

/**
 * React hook that listens to `beforeunload` window event.
 */
export function useBeforeUnload(enabled: boolean = false): void {
	useEffect(() => {
		if (!enabled) {
			return
		}
		const handleBeforeUnload = (event: BeforeUnloadEvent) => {
			event.preventDefault()
		}

		window.addEventListener("beforeunload", handleBeforeUnload)

		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload)
		}
	}, [enabled])
}
